import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
    name: 'OrganigramPage',
    components: {
        Organigram: require('../organigram/organigram.vue.html').default
    }
})
export default class OrganigramPage extends Vue {
    private accountSelected(): void {
        window.location.href = "Boards/List";
    }
}